import { render, staticRenderFns } from "./GoodsQrCode.vue?vue&type=template&id=67fbe29d"
import script from "./GoodsQrCode.vue?vue&type=script&lang=js"
export * from "./GoodsQrCode.vue?vue&type=script&lang=js"
import style0 from "./GoodsQrCode.vue?vue&type=style&index=0&id=67fbe29d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports